import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PlanDetailsComponent } from './plan-details.component';

const routes: Routes = [
    { path: 'enroll/esiid/:esiid/tdu/:tdu', component: PlanDetailsComponent, },
    { path: 'enroll/zipcode/:zipcode/tdu/:tdu', component: PlanDetailsComponent, },
    { path: 'enroll/esiid/:esiid', component: PlanDetailsComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanDetailsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/plan-details/plan-details-routing.module.ts